/** What the last Search asked for; each tab sends the part it uses. */
export interface ICouponQuery {
  from: string;
  to: string;
  partnerId: string;
  /** For the summary line only; never sent. */
  partnerName: string;
  minRate: number;
  code: string;
  brandId: string;
  country: string;
  platform: string;
  /** Raw events only. */
  status: "" | "Applied" | "Failed";
  error: string;
  eventId: string;
  /** Set by auto-refresh, so tabs keep their page; never sent. */
  refreshed?: boolean;
}

export const queryParams = (
  q: ICouponQuery,
  tab: "codes" | "insights" | "raw"
): URLSearchParams => {
  const p = new URLSearchParams();
  const set = (k: string, v: string) => v && p.set(k, v);
  set("from", q.from);
  set("to", q.to);
  set("partnerId", q.partnerId);
  set("code", q.code.trim());
  set("brandId", q.brandId);
  set("country", q.country.trim().toUpperCase());
  set("platform", q.platform);
  if (tab !== "raw") p.set("minRate", String(q.minRate));
  if (tab === "raw") {
    set("status", q.status);
    set("error", q.error);
    set("eventId", q.eventId);
  }
  return p;
};
